import Parlx from './parlx';

export default Parlx;
exports['default'] = Parlx;
module.exports = exports['default'];
